import { render } from "./ClassroomManagement.vue?vue&type=template&id=3772d53e"
import script from "./ClassroomManagement.vue?vue&type=script&lang=js"
export * from "./ClassroomManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__